<template>

	<div class="board_list">
		<ul class="default_list">

			<li class="notice" v-for="(item, index) in noticeList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="left_box">
						<div class="num">{{ item.idx }}</div>
						<em class="cate"> <span class="nc" v-if="item.isNotice">공지</span> <span>{{ item.cateName }}</span></em>
						<strong class="tit">{{ item.title }}</strong>
					</div>
					<div class="right_box" style="border: 0;">
						<div class="auth">{{ item.writerDec }}</div>
						<div class="date">{{ item.createDate | datetimeFilter }}</div>
						<div class="state ml-2" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
							<span :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' : !(item.statusName === '완료' || item.statusName === '확인') }">{{ item.statusName }}</span>
						</div>
					</div>
				</a>
			</li>



			<li v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="left_box">
						<div class="num">{{ item.idx }}</div>
						<em class="cate"><span class="nc" v-if="item.isNotice">공지</span> <span>{{ item.cateName }}</span></em>
						<strong class="tit">{{ item.title }}</strong>
					</div>
					<div class="right_box" style="border: 0;">
						<div class="auth">{{ item.writerDec }}</div>
						<div class="date">{{ item.createDate | datetimeFilter }}</div>
						<div class="state ml-2" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
							<span :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' : !(item.statusName === '완료' || item.statusName === '확인') }">{{ item.statusName }}</span>
						</div>
					</div>
					
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "listBasic",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}

	},
	watch: {
	}
}
</script>

<style scoped>

</style>